import { MARK_GOAL_MESSAGE_AS_OPENED } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (token: string, pdpId: string, goalId: string) =>
  fetch(MARK_GOAL_MESSAGE_AS_OPENED(pdpId, goalId), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }).then(errorHandler)
